<template>
    <div class="create_main">
        <div class="left_row">
            <div class="eng_rings">
                <div class="row align-items-center">
                    <div class="col-6 text-center slide_box">
                        <img width="220" height="220" src="/assets/new-eng-landing/ringgrid/cyo.png">
                    </div>
                    <div class="col-6">
                        <h5 class="font-active mb-2">Create Your Own</h5>
                        <p class="">Engagement Rings</p>
                        <div class="shop_now">
                        <NuxtLink :to="localePath({ name:'cyo-setting-list-ring'})">
                             shop now
                        </NuxtLink>
                        </div>
                    </div>
                </div>
               <div class="disc_chip_plp rec_box" v-if="!$country.is_india">Upto 50%</div>
            </div>
            <div class="eng_rings">
                <div class="row align-items-center">
                    <div class="col-6">
                        <h5 class="font-active mb-2">Pre-Designed</h5>
                        <p class="">Engagement Rings</p>
                        <div class="shop_now">
                            <NuxtLink :to="localePath({ name: 'preset-listing', 'RefreshKey': 'all'})">
                             shop now
                        </NuxtLink>
                        </div>
                    </div>
                    <div class="col-6 text-center slide_box">
                        <img width="220" height="220" src="/assets/new-eng-landing/ringgrid/preset.png">
                    </div>
                </div>
                <div class="disc_chip_plp rec_box" v-if="!$country.is_india">Upto 50%</div>
            </div>
            <div class="eng_rings">
                <div class="row align-items-center">
                    <div class="col-6 text-center slide_box">
                        <img width="220" height="220" src="/assets/new-eng-landing/ringgrid/instock.png">
                    </div>
                    <div class="col-6">
                        <h5 class="font-active mb-2">Ready To Ship</h5>
                        <p class="">Engagement Rings</p>
                        <div class="shop_now">
                            <NuxtLink :to="localePath({ name:'instock_ring', 'RefreshKey': 'all'})">
                             shop now
                        </NuxtLink>
                        </div>
                    </div>
                </div>
                <div class="disc_chip_plp rec_box" v-if="!$country.is_india">Upto 50%</div>
            </div>
        </div>
        <div class="right_row">
            <div class="eng_rings ">
                <div class="eng_rings_right">
                <div class="text">
                    <h5 class="font-active mb-2">Bespoke, Personalized</h5>
                    <p class="">Engagement Rings</p>
                    <div class="shop_now">
                        <NuxtLink :to="localePath('/customized-jewelry')">
                             shop now
                        </NuxtLink>
                    </div>
                </div>
                <div class="text-center">
                    <img width="220" height="250" src="/assets/new-eng-landing/ringgrid/Bespoke.gif"/>
                </div>
                </div>
                <!-- <div class="disc_chip_plp rec_box">Upto 50%</div> -->
            </div>
    
            <div class="pre_rings eng_rings_mod img_block for_desktop">
                    <img width="790" height="300" src="/assets/new-eng-landing/ringgrid/couple.gif">
            </div>
        </div>
    </div>
</template>


<script setup>
const localePath = useLocalePath();
const { $country } = useNuxtApp()
</script>


<style scoped>
/* Create your own seperate component */

.create_main {
display: flex;
justify-content: center;
margin: 0 auto;

}
.slide_box img{
transition: 0.5s;
}
.slide_box:hover img{
transform: scale(1.1);
transition: 0.5s;
}
.left_row{
display: flex;
flex-direction: column;
}
.eng_rings {
padding: 20px 32px;
border-radius: 8px;
background: #EAE9EA;
margin-bottom: 20px;
position: relative;
overflow: hidden;
flex: 1;
}
.rec_box {
font-weight: 600;
font-size: 12px;
color: #FEE4B3;
font-weight: 500;  
letter-spacing: 1px;
text-transform: uppercase;
}

h5{
margin: 0;
}
.left_row,
.right_row {
flex: 50%;
}

.left_row {
margin-right: 10px;
}

.right_row {
display: flex;
flex-direction: column;
margin-left: 10px;
}

.left_row .eng_rings:last-child {
margin-bottom: 0;
}

.eng_rings img {
max-width: 100%;
height: auto;
}

.eng_rings h5 {
font-size: 32px;
}

.eng_rings p {
color: #BE871A;
font-size: 16px;
letter-spacing: 2px;
text-transform: uppercase;
margin-bottom: 12px;
}

.shop_now {
letter-spacing: 3px;
color: #353535;
font-size: 18px;
text-transform: uppercase;
text-decoration: underline;
}
.shop_now a{
color: #353535;
}
.eng_rings_mod,
.pre_rings {
flex: 1;
}

.pre_rings {
margin-top: 0;
}

.eng_rings_mod {
display: flex;
flex: 1;
justify-content: space-between;
}

.eng_rings_mod img {
max-width: 100%;
height: auto;
border-radius: 8px;
}

.eng_rings_right {
text-align: center;
flex-direction: column;
}

.img_block img {
width: 100%;
height: auto;
max-height: 100%;
border-radius: 8px;
}
@media (max-width:1440px){
    .rec_box{
        font-size: 14px;
    }
    .shop_now{
        font-size: 16px;
        letter-spacing: 2px;
    }
    .eng_rings h5 {
        font-size: 28px;
    }
}
@media (max-width:1120px){
.eng_rings h5 {
font-size: 26px;
}
}
@media (max-width:992px) {

.eng_rings h5 {
font-size: 16px;
}

.shop_now {
font-size: 12px;
font-weight: 400;
letter-spacing: 1px;
}

.eng_rings p {
font-size: 12px;
letter-spacing: 1px;
}
}

@media (max-width: 767px) {
.eng_rings_mod {
display: flex;
flex-direction: row;
align-items: center;
}
.rec_box{
font-size: 8px;
}
.left_row .eng_rings:last-child {
margin-bottom: 12px;
}
.eng_rings{
margin-bottom: 12px;
}
.eng_rings h5, p , .shop_now{
padding-left: 5px;
}
.right_row{
margin-left: 0;
}
.left_row{
margin-right: 0;
}
.eng_rings_right {
display: flex;
justify-content: space-between;
align-items: center;
flex-direction: row;
text-align: left;
}

.eng_rings {
flex: 1 0 100%;
padding: 12px 16px;
}

.create_main {
flex-direction: column;
}

}
</style>